import axiosCall from './interceptor';
import URL, { strictEncode } from '../helper';

/**
 * Get list of business contracts
 * @param {string} search - Optional search term
 * @param {number} page - Page number (default: 1)
 * @param {number} limit - Items per page (default: 20, max: 100)
 * @returns {Promise} API response with contracts list
 */
export const getBusinessContracts = async (search = '', page = 1, limit = 20) => {
  const queryParams = new URLSearchParams();
  if (search) {
    queryParams.append('search', search);
  }
  queryParams.append('page', page.toString());
  queryParams.append('limit', Math.min(limit, 100).toString());
  
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts?${queryParams.toString()}`;
  const response = await axiosCall('get', url, {}, true, false);
  return response.data;
};

/**
 * Map a business contract to a document template
 * @param {number} businessContractId - ID of the business contract
 * @param {string} documentId - SQID encoded document ID
 * @returns {Promise} API response
 */
export const mapContractToTemplate = async (businessContractId, documentId) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts/mapping`;
  const payload = {
    businessContractId,
    documentId: strictEncode(documentId),
    mailTemplateId: null,
  };
  const response = await axiosCall('post', url, payload);
  return response.data;
};

/**
 * Unmap a business contract from a document template
 * @param {string} documentId - SQID encoded document ID
 * @returns {Promise} API response
 */
export const unmapContractFromTemplate = async (documentId) => {
  const encodedDocumentId = strictEncode(documentId);
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts/mapping?documentId=${encodedDocumentId}`;
  const response = await axiosCall('delete', url);
  return response.data;
};

/**
 * Get the current business contract mapping for a document template
 * @param {string} documentId - SQID encoded document ID
 * @returns {Promise} API response with mapping data
 */
export const getContractMapping = async (documentId) => {
  const encodedDocumentId = strictEncode(documentId);
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts/mapping?documentId=${encodedDocumentId}`;
  const response = await axiosCall('get', url, {}, true, false);
  return response.data;
};


